export default "__VITE_ASSET__zQcE_mby__"